"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartActionTypes = void 0;
var CartActionTypes;
(function (CartActionTypes) {
    CartActionTypes["ADD_ITEM"] = "ADD_ITEM";
    CartActionTypes["REMOVE_ITEM"] = "REMOVE_ITEM";
    CartActionTypes["UPDATE_ITEM_QUANTITY"] = "UPDATE_ITEM_QUANTITY";
    CartActionTypes["SET_CART_DATA"] = "SET_CART_DATA";
    CartActionTypes["SET_STRATEGY"] = "SET_STRATEGY";
    CartActionTypes["SET_CART_ITEMS"] = "SET_CART_ITEMS";
    CartActionTypes["CLEAR_CART"] = "CLEAR_CART";
    CartActionTypes["LOADING_CART"] = "LOADING_CART";
    CartActionTypes["LOADED_CART"] = "LOADED_CART";
    CartActionTypes["ERROR"] = "ERROR";
})(CartActionTypes = exports.CartActionTypes || (exports.CartActionTypes = {}));
